import { DSText, DSTextarea } from '@vr/ds-react'
import { Controller } from 'react-hook-form'

import { JustificationProps } from './type'

export const Justification = ({ methods, accountKey }: JustificationProps) => {
  return (
    <>
      <Controller
        key={accountKey}
        name='justificativa'
        control={methods.control}
        rules={{
          required: 'Este campo é obrigatório'
        }}
        render={({ field: { onChange, value } }) => (
          <DSTextarea
            disableResize
            label='Justificativa'
            maxLength={500}
            onChange={onChange}
            placeholder='Justificativa'
            value={value}
          />
        )}
      />
      {typeof methods.formState.errors.justificativa?.message === 'string' && (
        <DSText as='span' size='sm' weight='semibold' color='errorLight'>
          {methods.formState.errors.justificativa.message}
        </DSText>
      )}
    </>
  )
}
